// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2RSNj","image":"Header_image__3_0Gt","name":"Header_name__3pEs5","info":"Header_info__2yyuQ","infoRow":"Header_infoRow__1t0Ty"};